module.exports = __webpack_public_path__ + "static/media/infoviz.65d53324.jpg";